import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate'
})

export class TruncatePipe implements PipeTransform {

    transform(value: any, limit = 25, completeWords = false, ellipsis = '...') {
        const strValue = `${value}`;

        if (value === undefined) {
            return '';
        }

        if (strValue.length === 0) {
            return strValue;
        }

        if (completeWords) {
            limit = strValue.substr(0, limit).lastIndexOf(' ');
        }
        let sub = `${strValue.substr(0, limit)}`;

        if (strValue.length > limit) {
            sub = `${sub}${ellipsis}`;
        }

        return sub;
    }
}
